import { useMemo } from "react";
import { useParams } from "react-router-dom";
import Logboek24LandingPage from "./Logboek24LandingPage";

function normalizeSlug(value) {
  const raw = String(value || "home")
    .trim()
    .toLowerCase();
  const slug = raw
    .replace(/[^a-z0-9-]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  return slug || "home";
}

export default function PublicLandingBySlugPage() {
  const { slug } = useParams();
  const safeSlug = useMemo(() => normalizeSlug(slug), [slug]);
  return <Logboek24LandingPage slug={safeSlug} />;
}
